<template>
  <div id='pyramid'>
  <GChart
    :settings="{packages: ['corechart','bar']}"
    :data="chartdata"
    :options="chartOptions"
	:createChart="(el, google) => new google.charts.Bar(el)"
	@ready="onChartReady"
	:events="chartEvents"
	ref = "gChart"
  />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'pyramid',
  components: { GChart },
  props: ["chartdata","chartcolumns","years","categ","subcateg"],
  data() {
    return {
      chartsLib: null,
	  chartOptions: {
        height: 600,
        width: $('#charts').width(), //Google chart doesn't like height/width specified in any unit other than pixels
        animation: {
          duration: 400,
          startup: true
        },
		bars: 'horizontal', // Required for Material Bar Charts.
		stacked: true,
		axes:{x:{all:{format: ";"}}},
		colors: ['#d95f02']
      },
	  colsel: null,
	  igender: null,
	  chartEvents: {
        'select': () => {
          const colchart = this.$refs.gChart.chartObject;
          const selection = colchart.getSelection();
		  //console.log(this.chartcolumns);
		  //console.log(selection);
		  //console.log(this.chartdata);
		  //console.log(selection[0].column); //index of the suffix
		  //console.log(selection[0].row); //index of the prefix
		  //console.log(this.chartdata.length);
		  this.igender = selection[0].column;
		  var icol = (this.chartdata.length-selection[0].row-2)*2+selection[0].column-1
  		  this.colsel=this.chartcolumns[icol];
		  //console.log(this.colsel)

		  this.changeCol();
        }
      },
	}
  },
  computed: {
    lastYear() {
      return this.years[this.years.length-1]
    }
  },
  methods: {
    onChartReady (chart, google) {
      this.chartsLib = google;
	  google.visualization.events.addListener(chart, 'error', function (err) {
		if(err.message==''){
			$('#pyramid').load("#pyramid>*","");
		};
		// check error
		// remove error
		google.visualization.errors.removeError(err.id);
		// remove all errors
		//google.visualization.errors.removeAll(container);
	  });

    },
    runSerial(tasks) {
      var result = Promise.resolve();
      tasks.forEach(task => {
        result = result.then(() => task());
      });
      return result;
    },
    changeCol() {
	  var titlePrefix = this.subcateg.columns.filter(x => x.id == this.colsel)[0].title;
	  var titleSuffix = this.chartdata[0][this.igender];
	  var legendTitle = titlePrefix+'（'+titleSuffix+'）'
      let tasks = [
        () => { $('#categ1').val(this.categ.id).change() },
        () => { $('#categ2').val(this.subcateg.id).change() },
        () => { $('#year').val(this.lastYear).change() },
        () => { $('#legendtitle').val(legendTitle).change() },
        () => { $('#categ3').val(this.colsel).change() },
		() => { this.$root.$emit('retract_panel') }
      ]

      this.runSerial(tasks)
    }
  },
  watch: {
	chartsLib(){
		this.chartOptions = this.chartsLib.charts.Bar.convertOptions({
			height: 600,
			width: $('#charts').width(), //Google chart doesn't like height/width specified in any unit other than pixels
			animation: {
			duration: 400,
			startup: true
			},
			bars: 'horizontal', // Required for Material Bar Charts.
			bar: {groupWidth: "95%"},
			stacked: true,
			hAxis: {format: ";"},
			//series: {
			//	0:{color:'#1b9e77'},
			//	1:{color:'#d95f02'}
			//}
			colors: ['#d95f02']
		})
	}
  }
}
</script>

<style>

</style>
